/* NukkadTales — Home Page Wiring v8
   Depends on: nukkad-gul.js (loaded first), window.NT (data model from section inline scripts)
   Netlify base: https://cozy-dieffenbachia-95eb4b.netlify.app
*/
const NT_NETLIFY = 'https://cozy-dieffenbachia-95eb4b.netlify.app';
(function () {
  'use strict';

  /* ── helpers ── */
  let toastEl, toastT;
  function toast(m) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nt-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = m;
    toastEl.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('show'), 2200);
  }
  window.toast = window.ntToast = toast;

  function scrollToEl(el, off) {
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - (off || 10), behavior: 'smooth' });
  }

  function goSearch() {
    scrollToEl(document.getElementById('search'), 12);
    setTimeout(() => { const i = document.getElementById('ci'); if (i) i.focus(); }, 460);
  }
  function goCustomise() {
    const cutIn = document.getElementById('sayInput');
    const cutEl = document.getElementById('cutout');
    const v = (cutIn && cutIn.value || '').trim() || (cutEl && cutEl.textContent.trim()) || '';
    if (window.ntOpenSlider) {
      if (v) sessionStorage.setItem('nt_landing_text', v);
      else sessionStorage.setItem('nt_skip_welcome', '1');
      ntOpenSlider('customise');
    } else {
      scrollToEl(document.getElementById('customise'), 12);
      setTimeout(() => { if (cutIn) cutIn.focus(); }, 460);
    }
  }

  window.goSearch = window.ntGoSearch = goSearch;
  window.goCustomise = window.ntGoCustomise = goCustomise;

  /* ── Sticky nav + bottom bar reveal ── */
  const heroEl = document.getElementById('nt-hero');
  const nbar = document.getElementById('nbar');
  const bbar = document.getElementById('bbar');
  const cgFab = document.getElementById('nt-cgfab');

  function onScroll() {
    const past = window.scrollY > 60;
    if (nbar) nbar.classList.toggle('show', heroEl ? window.scrollY > heroEl.offsetHeight - 70 : past);
    if (bbar) bbar.classList.toggle('show', heroEl ? window.scrollY > heroEl.offsetHeight - 70 : past);
    if (cgFab) cgFab.classList.toggle('show', past);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── Featured collection band ── */
  function buildFeatured() {
    const card = document.getElementById('fbCard');
    if (!card) return;
    const FEATURED = window.NT_FEATURED;
    if (!FEATURED || !FEATURED.keys) return;

    const products = (window.NT && window.NT.PRODUCTS)
      ? window.NT.PRODUCTS.filter(p => FEATURED.keys.indexOf(p.title) >= 0).slice(0, 3)
      : [];

    const clock = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="8" cy="8.5" r="6"></circle><line x1="8" y1="8.5" x2="8" y2="5"></line><line x1="8" y1="8.5" x2="10.2" y2="9.6"></line></svg>';

    let h = `<div class="fb-eyebrow">&#10022; ${FEATURED.eyebrow}</div>`;
    h += `<div class="fb-title">${FEATURED.title}</div>`;
    h += `<div class="fb-blurb">${FEATURED.blurb}</div>`;

    if (products.length) {
      h += '<div class="fb-row">' + products.map(p =>
        `<div class="fb-item" onclick="goFeatured()">
          ${p.imageUrl
            ? `<img src="${p.imageUrl}" alt="${p.title}" style="width:100%;height:104px;object-fit:cover;border-radius:12px;background:var(--card)">`
            : `<div style="width:100%;height:104px;border-radius:12px;background:var(--card);display:flex;align-items:center;justify-content:center;font-family:var(--ff);font-style:italic;font-size:12px;color:var(--muted);padding:8px;text-align:center;">${p.title}</div>`
          }
          <div class="fb-in">${p.title}</div>
          <div class="fb-ip">&#8377;599</div>
        </div>`
      ).join('') + '</div>';
    }

    h += `<div class="fb-foot">
      <div class="fb-cue">${clock}<span>${FEATURED.cue}</span></div>
      <button class="fb-cta" onclick="goFeatured()">${FEATURED.cta} &rarr;</button>
    </div>`;

    card.innerHTML = h;
  }

  function goFeatured() {
    const p = document.getElementById('products');
    if (p) scrollToEl(p, 12);
    setTimeout(() => {
      document.querySelectorAll('#ptabs .tab').forEach(x => {
        x.classList.toggle('on', x.getAttribute('data-tab') === (window.NT_FEATURED && window.NT_FEATURED.tag));
      });
      if (window.NT_FEATURED) renderProducts(window.NT_FEATURED.tag);
    }, 420);
  }
  window.goFeatured = window.ntGoFeatured = goFeatured;

  /* ── Products grid ── */
  const COLL_COLOR = {
    'Happy Homes': 'studio',
    'Character':   'dark',
    'Slow Living': 'sage',
    'Rise & Shine':'olive',
    'Together':    'blush'
  };

  function pieceStage(p) {
    const scheme = COLL_COLOR[p.coll] || 'studio';
    const isDark = scheme === 'dark';
    const lines = p.title.split(' ');
    const mid = Math.ceil(lines.length / 2);
    const line1 = lines.slice(0, mid).join(' ');
    const line2 = lines.slice(mid).join(' ');
    const qText = line2 ? `${line1}<br>${line2}` : line1;
    const glow = isDark ? `<span class="piece-glow" style="width:60px;height:60px;left:30%;top:10%"></span><span class="piece-glow" style="width:40px;height:40px;right:20%;top:20%"></span>` : '';
    return `<div class="pstage piece p-${scheme}">${glow}<div class="piece-q">${qText}</div><div class="piece-shelf"></div></div>`;
  }

  function pcard(p) {
    const stage = p.imageUrl
      ? `<div class="pstage"><img src="${p.imageUrl}" alt="${p.title}" style="width:100%;height:100%;object-fit:cover;"></div>`
      : pieceStage(p);
    const badge = p.badge ? `<div class="pbadge">${p.badge}</div>` : '';
    const url = p.url || '';
    const tag = url ? `<a class="pcard" href="${url}">` : `<div class="pcard" onclick="toast('Opening ${p.title.replace(/'/g, '')}')">`;
    const end = url ? '</a>' : '</div>';
    return `${tag}<div style="position:relative">${stage}${badge}</div>
      <div class="pb">
        <div class="ptag">${p.coll}</div>
        <div class="pn">${p.title}</div>
        <div class="pf"><div class="pp">&#8377;599 <span>ready</span></div><div class="padd">+</div></div>
      </div>
    ${end}`;
  }

  function renderProducts(tab) {
    const grid = document.getElementById('pgrid');
    if (!grid || !window.NT || !window.NT.PRODUCTS) return;
    let list;
    const FEATURED = window.NT_FEATURED;
    if (FEATURED && tab === FEATURED.tag) {
      list = window.NT.PRODUCTS.filter(p => FEATURED.keys.indexOf(p.title) >= 0);
    } else if (tab === 'All') {
      list = window.NT.PRODUCTS.slice(0, 6);
    } else {
      list = window.NT.PRODUCTS.filter(p => p.coll === tab);
    }
    grid.innerHTML = list.map(pcard).join('');
  }
  window.renderProducts = window.ntRenderProducts = renderProducts;

  function buildProductTabs() {
    const tabsEl = document.getElementById('ptabs');
    if (!tabsEl || !window.NT || !window.NT.TABS) return;
    const FEATURED = window.NT_FEATURED;
    const tabsHTML = window.NT.TABS.map((t, i) =>
      `<button class="tab${i === 0 ? ' on' : ''}" data-tab="${t}">${t}</button>`
    );
    if (FEATURED) {
      tabsHTML.splice(1, 0, `<button class="tab feat" data-tab="${FEATURED.tag}"><span class="fdot"></span>&#10022; ${FEATURED.tag}</button>`);
    }
    tabsEl.innerHTML = tabsHTML.join('');
    tabsEl.addEventListener('click', e => {
      const b = e.target.closest('.tab'); if (!b) return;
      tabsEl.querySelectorAll('.tab').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      renderProducts(b.getAttribute('data-tab'));
    });
    renderProducts('All');
  }

  /* ── Trust ticker ── */
  function buildTicker() {
    const t = document.getElementById('ticker'); if (!t) return;
    const TRUST = window.NT_TRUST || [
      'Hand-cut &amp; hand-painted','Ships in 5 days','Loved in 1.5L+ homes',
      'Solid wood &middot; no machines','4.9&#9733; on 1,860 tales','Made in India',
      'Wrapped ready to gift'
    ];
    const items = TRUST.map(w => `<span class="it">${w}</span>`).join('');
    t.innerHTML = `<div class="grp">${items}</div><div class="grp">${items}</div>`;
  }

  function pillGo(label) {
    if(typeof ntSendToChip==='function'){ntSendToChip(label);return;}
    try{sessionStorage.setItem('nt_landing_text',label);}catch(e){}
    if(typeof ntOpenSlider==='function'){ntOpenSlider('customise');return;}
    // fallback: fill ci and open Ask Gul
    const inp = document.getElementById('ci');
    if (inp) { inp.value = label + ', '; }
    if (typeof openAg === 'function') openAg();
  }
  window.pillGo = window.ntPillGo = pillGo;

  /* ── AI band ── */
  function buildAICloud() {
    const cloud = document.getElementById('nineCloud'); if (!cloud) return;
    const MARQ = [
      'Ghar wapsi','Dil garden garden','Thoda sukoon','For the one who stayed',
      'Apna time aayega','House of Smiles','Sabr Shukr','Param Mitr',
      'Khana khaya?','Born To Shine','Naya ghar','Better together',
      'I am my favourite','Khush raho','Sukoon','Apnapan','Chai pe charcha'
    ];
    const nc = MARQ.slice(0, 10).map(s => `<span class="chip">${s}</span>`).join('');
    cloud.innerHTML = `<div class="row">${nc}${nc}</div>`;
  }

  function aiTry() {
    if (typeof openAg === 'function') openAg();
    else if (typeof goSearch === 'function') goSearch();
  }
  window.aiTry = window.ntAiTry = aiTry;

  /* ── Overheard rotation ── */
  const OH_DEFAULT = [
    { l: '&ldquo;Khana khaya?&rdquo;', a: 'one papa &middot; every evening &middot; Indore' },
    { l: '&ldquo;Sabr, beta.&rdquo;', a: 'a mother &middot; by the stove &middot; Bhopal' },
    { l: '&ldquo;Aa gaye? Good.&rdquo;', a: 'a watchman &middot; to everyone &middot; Pune' },
    { l: '&ldquo;Khush raho.&rdquo;', a: 'a grandmother &middot; at every goodbye &middot; Jaipur' },
    { l: '&ldquo;Chai pee ke jaana.&rdquo;', a: 'every house &middot; always &middot; everywhere' },
    { l: '&ldquo;Pohch ke batana.&rdquo;', a: 'a sister &middot; every single time &middot; Lucknow' }
  ];

  function buildOverheard() {
    const ohLine = document.getElementById('ohLine');
    const ohAttr = document.getElementById('ohAttr');
    if (!ohLine || !ohAttr) return;

    /* Use NT_OH only if it has items — empty array falls back to defaults */
    const OH = (window.NT_OH && window.NT_OH.length) ? window.NT_OH : OH_DEFAULT;
    let oi = 0;

    function bow() {
      try {
        const g = window._ntSitGul;
        if (!g) return;
        const le = g.leanEl;
        le.style.transition = 'transform .6s cubic-bezier(.3,1,.4,1)';
        le.style.transform = 'rotate(8deg) translateY(2px)';
        setTimeout(() => { le.style.transform = 'rotate(0) translateY(0)'; }, 560);
      } catch(e) {}
    }

    function rotOH() {
      const bubble = document.getElementById('nt-bubble');
      if (bubble && bubble.classList.contains('show')) return;
      oi = (oi + 1) % OH.length;
      ohLine.classList.add('out'); ohAttr.classList.add('out');
      setTimeout(() => {
        ohLine.innerHTML = OH[oi].l;
        ohAttr.innerHTML = '&mdash; ' + OH[oi].a;
        ohLine.classList.remove('out'); ohAttr.classList.remove('out');
        bow();
      }, 520);
    }
    setInterval(rotOH, 4600);
  }

  /* ── Proof collage — populated via Liquid blocks in theme editor ── */
  function buildProof() {}

  /* ── Craft section ── */
  window.craftPlay = window.ntCraftPlay = function () {
    const v = document.getElementById('craftVid');
    if (v && (v.currentSrc || v.querySelector('source'))) {
      v.paused ? v.play() : v.pause();
    } else {
      toast('Artisan film &mdash; drop a 30&ndash;60s clip in');
    }
  };

  /* ── Load live data from Netlify ── */
  function loadGulStories() {
    fetch(NT_NETLIFY + '/.netlify/functions/nt-tales')
      .then(r => r.json())
      .then(tales => {
        if (!Array.isArray(tales) || !tales.length) return;
        window.NT_LIVE_STORIES = tales.filter(t => t.active !== false).map(t => t.text);
      })
      .catch(() => {});
  }

  function loadCatalog() {
    fetch(NT_NETLIFY + '/.netlify/functions/nt-catalog-serve')
      .then(r => r.json())
      .then(catalog => {
        if (!Array.isArray(catalog) || !catalog.length) return;
        if (window.NT && window.NT.PRODUCTS) {
          window.NT.PRODUCTS.forEach(p => {
            const live = catalog.find(c => (c.title || c.name) === p.title);
            if (live && live.imageUrl) p.imageUrl = live.imageUrl;
            else if (live && live.image) p.imageUrl = live.image;
            else if (live && live.images && live.images[0]) p.imageUrl = live.images[0];
          });
        }
        renderProducts('All');
        buildProof();
      })
      .catch(() => {});
  }

  function loadReviews() {
    fetch(NT_NETLIFY + '/.netlify/functions/nt-reviews')
      .then(r => r.json())
      .then(data => {
        const reviews = data && data.reviews;
        if (!reviews || !reviews.length) return;
        const testi = document.querySelector('.testi blockquote');
        const who   = document.querySelector('.testi .who cite');
        const best  = reviews[0];
        if (testi && best) testi.textContent = '"' + best.body + '"';
        if (who   && best) who.textContent   = best.name + (best.date ? ' · ' + best.date.slice(0,7) : '');

        // collage is managed via theme editor blocks — no API override
      })
      .catch(() => {});
  }

  /* ── Call Gul FAB (Foxify-safe: all JS here, not in snippet IIFE) ── */
  function wireCallGulFab() {
    var fab = document.getElementById('nt-cgfab');
    if (!fab) return;

    var cgBusy = false, flyGulG = null;

    var CG_STORIES = [
      "One papa never says 'I love you'. {pause} He says 'khana khaya?' {blink2} Same thing only.",
      "One aunty has 'sabr' written near her kitchen. {pause} She says it has saved many chappals from flying. {giggle}",
      "One watchman greets every single person by name. {pause} Two hundred names he knows. {blink} Everyone walks in a little taller.",
      "Two sisters fight on the phone every day. {pause} But if one doesn't call, {tilt} the other one panics. {giggle} Love only, in loud form.",
      "One boy hung 'welcome home' on the door for his mother, back from hospital. {pause} She cried right there at the door. {blink} Happy crying.",
      "One papa doesn't say much. But every time you leave the house, he comes to the door. Stands there till the auto turns the corner. Every time.",
      "A maa who has never once eaten before her children. Not in thirty years. Not even when they're grown and gone. She still waits.",
      "One papa found out his son got the job. Didn't say anything. Called the panditji that evening. Booked a puja. That's how the son found out his father was proud.",
      "One papa's way of saying I missed you is to find something broken in your house and fix it without telling you. You come home and the fan works again.",
      "A maa learns one new thing on the phone every time her child visits. Last time it was screenshot. This time it is Google Maps. She is unstoppable now, slowly.",
      "One father irons his children's clothes on exam day. They are adults. He still irons. Nobody has told him to stop. Nobody will.",
      "One papa's entire vocabulary of affection is — khaya? Same question, morning and night, on call and in person. You know what it means. You've always known.",
      "A maa whose child moved to another city cooks that child's favourite sabzi every Friday. Puts it in the fridge. Eats it alone on Saturday. Says it tastes different when you cook it for someone.",
      "One papa refills your water bottle before every trip. Every single time. You have never once asked him to. He has never once not done it.",
      "A maa memorised her child's new address in three days. Wrote it on a piece of paper. Keeps it in her purse. Just in case she needs to come.",
      "One dadi keeps a small box of cash in the rice dabba for emergencies. The whole family knows. Nobody has ever taken it. Everyone sleeps a little better knowing it's there.",
      "A nana who never shows emotion saves the newspaper for his grandchildren's visit so they can read together. Has done this for nine years. They are now on their phones. He still saves the paper.",
      "One dadi prays for each person in the house by name, in order, every morning. If you are added to the family — by birth, by marriage, by just being around long enough — you get added to the list.",
      "One house has four generations under one roof. The youngest asks the oldest for a story every night. The oldest never says she is tired. She is always tired. She never says it.",
      "One joint family has argued about the same topic — who makes better chai, maa or bhabhi — for twelve years. The argument has no answer. The argument is the point.",
      "One couple has been married forty years and still sleeps on the same sides of the bed they chose on the first night. Nobody decided this. It just stayed.",
      "A husband who travels for work calls from every new city to say he reached. His wife always says haan haan like she wasn't waiting. She was waiting.",
      "One wife packs her husband's bag because he will forget something important. In twenty-three years of marriage he has packed it himself exactly twice. She doesn't mention this.",
      "One couple fights loudly. Makes up quietly. No announcement, no sorry-sorry. One person just makes chai. The other one drinks it. This is the whole process.",
      "One husband's job at every family function is to find his wife in the crowd and stay near her. She doesn't ask him to. He just appears. She pretends not to notice. She always notices.",
      "One couple has never once said I love you to each other. Have been married thirty-eight years. Their children have never once doubted it.",
      "One best friend calls on the bad anniversaries. Not the good ones — everyone calls on those. She calls on the day you lost something. Just to say — I remembered.",
      "A friend group has a WhatsApp chat from 2014. Someone sends a meme at 2am. Everyone is there within three minutes. This is their fastest communication. Nothing else gets this response time.",
      "One friend took a train twelve hours to be at your function. Didn't tell you she was coming. Just appeared. Said — arre, itna bhi kya. Like it was nothing. It was everything.",
      "Two friends who haven't lived in the same city in eight years still know each other's moods by the speed of the reply. Fast reply — she's okay. Late reply — something happened. No reply — call immediately.",
      "One yaar shows love by roasting you in front of everyone and defending you behind your back. This is confusing to outsiders. To you it is the clearest thing in the world.",
      "One household runs entirely on chai. Good news — chai. Bad news — chai. Guest comes — chai. Guest takes too long to leave — one more chai. The chai is never the point. The chai is always the point.",
      "A dabba from home reaches office with exactly the right amount of everything. Not because it was calculated. Because the person who packed it has watched you eat for twenty years and knows.",
      "One family's Sunday smells the same as it has for thirty years. Slow-cooked, early morning, before anyone is awake. You wake up and you know immediately — it's Sunday, you're home.",
      "A nani's hands make the same atta every morning. Same movement, same pressure, same time. If you close your eyes it sounds like childhood. It always will.",
      "One neighbourhood aunty brings food when someone is sick — without being asked, without calling ahead. She just appears at the door with a tiffin. Everyone in the colony knows. Nobody knows how she finds out.",
      "A chai wala near the old bus stand knows three hundred orders by face. No names needed. You sit, he looks at you once, it comes. This has taken him fifteen years to learn. He considers it nothing special.",
      "One building's watchman knows who is going through a hard time by how they walk to the gate. He says nothing. Just nods a little slower that day. His regulars know what the slow nod means.",
      "A kirana bhaiya knows your ration without a list. Has known it for eight years. Packs it before you finish saying hello. A stranger has paid this much attention to your life.",
      "One autowaala plays old film songs and drives slower near hospitals. Nobody asked him to. He started doing it one day and never stopped. He thinks nobody notices. His repeat passengers notice.",
      "A sabziwala gives an extra handful of dhania to regulars who have bought from him for more than five years. He has never announced this policy. They have never mentioned it. Both parties understand.",
      "One dadi does her puja at the same time every morning. Has done this for fifty-one years. The gods in the mandir corner are small and old and the vermilion is never missing. The house has been built around this ritual.",
      "A family has a tulsi plant in the courtyard that has been there since before the youngest child was born. Every morning the maa waters it before she does anything else. Before chai, before conversation, before the day begins.",
      "One nana goes to the Gurudwara every morning before the rest of the house wakes up. Comes back with a small piece of karah prasad wrapped in a cloth. Leaves it on the kitchen counter. Nobody has ever asked him to. It is simply there.",
      "A dadi fasts on certain days — has done so for sixty years. Her children said she doesn't need to anymore. She looked at them the way you look at someone who has missed the point entirely.",
      "One family lights a diya at the mandir corner every evening without fail. Not for any festival. Not for any occasion. Because the evening came and the day needed to be marked. That's all.",
      "A Sikh grandfather touches his kara before every difficult conversation. Has done this his whole life. His grandchildren noticed. Now they touch his kara too, before exams, before results, before anything that matters.",
      "One woman who had a very hard year kept one small tulsi plant alive through all of it. She considers this her proof that she managed. It is proof.",
      "A man who rebuilt his shop after the flood put the same name on the new board. His son asked why the same name. He said — the name was never in the flood.",
      "One nani ends every phone call with khush raho. Not bye, not take care. Just — be happy. Like it's an instruction. Like she is certain you can follow it if you try.",
      "A doctor has been practicing for thirty years and still reads up on every complicated case the night before. Her residents think she just knows everything. She does not just know everything.",
      "One teacher writes one kind word on every paper she returns. Has done this for twenty-four years. Some of those students are teachers now. They do the same thing. They didn't decide to. It just felt right.",
      "A man started his business in one small room. The room is now a floor. The desk is still in the corner. He hasn't moved it. Everyone has learned not to ask why.",
      "One papa dropped his daughter to the airport. Waited outside till she went through security. Drove home alone. Called her when he reached to ask pahunch gayi? She had just left two hours ago. He knows. He called anyway.",
      "A child's drawing of the family puts the dog in the centre. The family agreed this was correct.",
      "A family WhatsApp group has forty-nine members. Twelve are arguing, seven are sharing recipes, four are sending good morning photos, three are asking for prayers. This is all happening at the same time. This is a family.",
      "One boy made a welcome home banner when his maa came back from the hospital. Made it himself with chart paper and sketch pens. Cried while making it. Made sure to finish before she arrived.",
      "A maa learns her child's new city by Google Maps. Looks at the satellite view of the building. Zooms in. This is how she visits."
    ];
    var cgStIdx = Math.floor(Math.random() * CG_STORIES.length);
    var CG_OPENERS = [
      "Okay, okay… {pause} one tale.",
      "One more? {giggle} You like them, na…",
      "Arrey, again? {tilt} Okay okay, fine…",
      "Hmm, which one… {pause} okay. This one.",
      "{giggle} You and me, same only. {pause} Listen…"
    ];

    function initCgGul() {
      if (!window.makeGul) { setTimeout(initCgGul, 100); return; }
      var cgRoot = document.getElementById('nt-callGul');
      if (cgRoot) { var g = window.makeGul(cgRoot, 46); if (g) g.setFace(window.F.closed); }
    }
    initCgGul();

    function getFlyGul() {
      if (!flyGulG) {
        var root = document.getElementById('nt-flyGul');
        if (root && window.makeGul) flyGulG = window.makeGul(root, 92);
      }
      return flyGulG;
    }
    function flyPos(x, y) {
      var el = document.getElementById('nt-flyGul');
      if (el) { el.style.left = x + 'px'; el.style.top = y + 'px'; }
    }
    async function cgFlapTo(g, x, y, ms) {
      var el = document.getElementById('nt-flyGul');
      if (!el) return;
      var up = true;
      var fl = setInterval(function() { g.frame(up ? window.F.fup : window.F.fdn); up = !up; }, 110);
      el.style.transition = 'left ' + ms + 'ms cubic-bezier(.4,.15,.4,1),top ' + ms + 'ms ease-in-out';
      void el.offsetWidth;
      flyPos(x, y);
      await window.wait(ms);
      clearInterval(fl);
      g.frame(g.base);
    }
    function bubbleGone() {
      return new Promise(function(res) {
        var b = document.getElementById('nt-bubble'), n = 0;
        (function chk() { if (!b || !b.classList.contains('show') || n++ > 60) return res(); setTimeout(chk, 120); })();
      });
    }

    window.ntGulStory = async function() {
      if (cgBusy) return;
      var g = getFlyGul(); if (!g) return;
      cgBusy = true;
      var el = document.getElementById('nt-flyGul');
      if (!el) { cgBusy = false; return; }
      var w = window.innerWidth, h = window.innerHeight;
      el.style.display = 'block'; el.style.transition = 'none';
      g.flip.style.transform = 'scaleX(1)';
      flyPos(-120, h * 0.42);
      await window.wait(40);
      await cgFlapTo(g, w * 0.5 - 46, h * 0.40, 950);
      g.frame(window.F.closed);
      if (window.chirp) window.chirp();
      await g.tell(CG_OPENERS[cgStIdx < CG_OPENERS.length ? cgStIdx : 3 + (cgStIdx % 2)]);
      await window.wait(220);
      var _pool = (window.NT_LIVE_STORIES && window.NT_LIVE_STORIES.length) ? window.NT_LIVE_STORIES : CG_STORIES;
      var _next; do { _next = Math.floor(Math.random() * _pool.length); } while (_pool.length > 1 && _next === cgStIdx);
      cgStIdx = _next;
      await g.tell(_pool[cgStIdx]);
      await bubbleGone(); await window.wait(140);
      await cgFlapTo(g, w + 90, h * 0.30, 840);
      el.style.display = 'none';
      cgBusy = false;
    };

    window.ntGulFeed = async function() {
      if (cgBusy) return;
      var g = getFlyGul(); if (!g) return;
      cgBusy = true;
      var el = document.getElementById('nt-flyGul');
      var food = document.getElementById('nt-gulFood');
      if (!el) { cgBusy = false; return; }
      var w = window.innerWidth, h = window.innerHeight;
      var bx = w * 0.40 - 46, by = h * 0.40;
      el.style.display = 'block'; el.style.transition = 'none';
      g.flip.style.transform = 'scaleX(1)';
      flyPos(-120, h * 0.42);
      await window.wait(40);
      await cgFlapTo(g, bx, by, 900);
      g.frame(window.F.sit);
      if (food) {
        food.style.cssText = 'position:fixed;font-size:18px;pointer-events:none;z-index:201;transition:none;opacity:1;transform:scale(1);left:' + (bx+84) + 'px;top:' + (by+66) + 'px;display:block;';
        await window.wait(60);
        food.style.transition = 'opacity .3s,transform .3s';
        for (var i = 0; i < 3; i++) {
          if (window.chirp) window.chirp();
          g.frame(window.F.peck); await window.wait(250);
          g.frame(window.F.sit); await window.wait(190);
          food.style.opacity = String(1 - (i+1)/3);
          food.style.transform = 'scale(' + (1 - (i+1)*0.26) + ')';
        }
        food.style.display = 'none';
      }
      g.setFace(window.F.happy);
      await g.tell("Thank you! {giggle}");
      await bubbleGone(); await window.wait(120);
      await cgFlapTo(g, w + 110, h * 0.30, 840);
      el.style.display = 'none'; g.setFace(window.F.closed);
      cgBusy = false;
    };

    window.ntToggleCallGul = function() { fab.classList.toggle('open'); };
    window.ntCgClose = function() { fab.classList.remove('open'); };

    document.addEventListener('click', function(e) {
      if (!fab.contains(e.target)) fab.classList.remove('open');
    });
  }

  /* ── Occasion pills (Foxify-safe: event delegation from external JS) ── */
  function wireOccasionPills() {
    var form = document.querySelector('.cust-form');
    if (!form) return;
    form.addEventListener('click', function (e) {
      var pill = e.target.closest('.occ-pill[data-occ]');
      if (!pill) return;
      var val = pill.getAttribute('data-occ');
      var input = document.getElementById('sayInput');
      if (input) {
        input.value = val;
        input.dispatchEvent(new Event('input'));
        input.focus();
      }
      form.querySelectorAll('.occ-pill').forEach(function (p) { p.classList.remove('on'); });
      pill.classList.add('on');
    });
  }

  /* ── Product tab switching (Foxify-safe: runs from external JS, not section inline) ── */
  function wireProductTabs() {
    var tabsEl = document.getElementById('ptabs');
    if (!tabsEl) return;
    /* Enforce initial visibility state — CSS alone can't guarantee this because
       Foxify may load external CSS after the section HTML is painted */
    var activeBtn = tabsEl.querySelector('.tab.on');
    if (activeBtn) {
      var initKey = activeBtn.getAttribute('data-tab');
      document.querySelectorAll('#pgrid .pcard[data-tab]').forEach(function (c) {
        c.classList.toggle('tab-visible', c.getAttribute('data-tab') === initKey);
      });
    }
    tabsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.tab[data-tab]');
      if (!btn) return;
      var tabKey = btn.getAttribute('data-tab');
      tabsEl.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('on'); });
      btn.classList.add('on');
      document.querySelectorAll('#pgrid .pcard[data-tab]').forEach(function (c) {
        c.classList.toggle('tab-visible', c.getAttribute('data-tab') === tabKey);
      });
    });
    /* See-all button: navigate to the active tab's collection */
    document.addEventListener('click', function(e){
      if(!e.target.closest('[data-seeall]')) return;
      var activeTab=tabsEl.querySelector('.tab.on');
      var handle=activeTab&&activeTab.getAttribute('data-tab');
      window.location.href=handle?'/collections/'+handle:'/collections/all';
    });

    /* Also expose ntTab for any legacy callers */
    window.ntTab = function (btn, tabKey) {
      tabsEl.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('on'); });
      btn.classList.add('on');
      document.querySelectorAll('#pgrid .pcard[data-tab]').forEach(function (c) {
        c.classList.toggle('tab-visible', c.getAttribute('data-tab') === tabKey);
      });
    };
  }

  /* ── init on DOMContentLoaded ── */
  function init() {
    wireCallGulFab();
    wireOccasionPills();
    wireProductTabs();
    buildFeatured();
    buildProductTabs();
    buildTicker();
    buildAICloud();
    buildOverheard();
    buildProof();
    loadGulStories();
    loadCatalog();
    loadReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* openAg / closeAg / agtMode / pillGo are now in nukkad-ask-gul.js (loaded on all pages) */;
